import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../environments/environment';

export type RuntimePlatform = 'web' | 'capacitor' | 'electron';

@Injectable({
  providedIn: 'root'
})
export class PlatformService {
  constructor(@Inject(PLATFORM_ID) private readonly platformId: object) {}

  isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  getRuntimePlatform(): RuntimePlatform {
    return (environment.runtimePlatform ?? 'web') as RuntimePlatform;
  }

  getLocationHostname(): string {
    if (!this.isBrowser()) {
      return '';
    }
    return window.location.hostname;
  }

  getLocationSearch(): string {
    if (!this.isBrowser()) {
      return '';
    }
    return window.location.search;
  }

  getViewportWidth(): number {
    if (!this.isBrowser()) {
      return 0;
    }
    return window.innerWidth;
  }

  getViewportHeight(): number {
    if (!this.isBrowser()) {
      return 0;
    }
    return window.innerHeight;
  }

  addWindowEventListener<K extends keyof WindowEventMap>(
    eventName: K,
    handler: (event: WindowEventMap[K]) => void
  ): void {
    if (!this.isBrowser()) {
      return;
    }
    window.addEventListener(eventName, handler as EventListener);
  }

  removeWindowEventListener<K extends keyof WindowEventMap>(
    eventName: K,
    handler: (event: WindowEventMap[K]) => void
  ): void {
    if (!this.isBrowser()) {
      return;
    }
    window.removeEventListener(eventName, handler as EventListener);
  }

  getNavigatorLanguage(): string {
    if (!this.isBrowser() || typeof navigator === 'undefined') {
      return 'pl';
    }
    return navigator.language || 'pl';
  }

  decodeBase64(value: string): string {
    if (!this.isBrowser()) {
      return '';
    }
    return atob(value);
  }
}